import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { APIURL } from "../../../config";
import axios from "axios";


const TaskBillingRatesGrid = (props) => {
  const [rows, setRows] = useState([]);

  const columns = [
  { field: "id", headerName: "ID", hide: true },
  { field: "procedureCode", headerName: "Procedure Code", flex: 1 },
  { field: "customerTier", headerName: "Customer Tier", flex: 1 },
  { field: "procedureModifierCode", headerName: "Procedure Modifier Code", flex: 1 },
  { field: "billingRate", headerName: "Billing Rate", flex: 1, 
    valueFormatter: (params) => 
      params.value
  },
];

  useEffect(() => {
    const fetchBillingRates = async () => {
      try {
        const response = await axios.get(APIURL + '/billingrates/mapped', { params: { company_id: props.comp_id } });
        console.log(response.data);
        const mappedRows = response.data.map(item => ({
          id: item.billingrate_id,
          procedureCode: item.procProcCode,
          customerTier: item.tier,
          procedureModifierCode: item.procModifierCode || "",
          billingRate: item.rate
        }));
        setRows(mappedRows);
      } catch (error) {
        setRows([]);
      }
    };
    fetchBillingRates();
  }, [props.comp_id]);

  return (
    <div style={{ height: 400, width: "100%" }}>
      <DataGrid
        columns={columns}
        rows={rows}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
        showToolbar
      />
    </div>
  );
};

export default TaskBillingRatesGrid;